import { useEffect, useRef, useState } from "react";
import { countryCode } from "./countryCode";
import { lngProps } from "interface";
import i18n from "locales/i18n";
import "./phone.scss";

type phoneProps = {
  code: string;
  ko: string;
  en: string;
  phone: string;
  value?: string;
};

type IProps = {
  styles?: string;
  ulStyles?: string;
  dataTyp?: "C" | "R";
  isReset?: boolean;
  onSelect?: (option: any) => void;
};

export default function PhoneSelect({
  ulStyles = "",
  styles = "",
  dataTyp = "C",
  isReset = false,
  onSelect,
}: IProps) {
  const lng = i18n.language;
  const selectRef = useRef<HTMLDivElement>(null);
  const [item, setItem] = useState<phoneProps>();
  const [isOpen, setIsOpen] = useState(false);

  const outSideClick = (e: any) => {
    if (selectRef.current && !selectRef.current.contains(e.target)) {
      setIsOpen(false);
      selectRef.current.style.setProperty("--icon-rotate", "180deg");
    }
  };

  useEffect(() => {
    document.addEventListener("click", outSideClick);

    return () => {
      document.removeEventListener("click", outSideClick);
    };
  }, []);

  let defult = countryCode[0].phone;

  useEffect(() => {
    if (isReset) {
      setItem(countryCode[0]);
    }
  }, [isReset]);

  return (
    <div
      role="phone"
      className={styles}
      ref={selectRef}
      onClick={(e) => {
        e.currentTarget.style.setProperty(
          "--icon-rotate",
          isOpen ? "180deg" : "0deg"
        );
      }}
    >
      <input
        type="text"
        value={item?.phone ? "+" + item.phone : "+" + defult}
        name={"mobCntyCd"}
        className=""
        readOnly
        data-create
        data-type={dataTyp}
        data-value={item?.phone || defult}
        onClick={(e) => {
          setIsOpen(!isOpen);
          e.currentTarget.removeAttribute("data-create");
          e.currentTarget.setAttribute("data-modify", "true");
        }}
      />

      <ul className={ulStyles} hidden={!isOpen}>
        {countryCode.map((cnty: phoneProps) => {
          return (
            <li
              key={cnty?.code}
              data-value={cnty.phone}
              data-check={item?.phone === cnty.phone || cnty.phone === defult}
              onClick={(e) => {
                setItem(cnty);
                setIsOpen(false);
                onSelect && onSelect(cnty.phone);

                const parent = e.currentTarget.closest(
                  "div[role='phone']"
                ) as HTMLDivElement;
                const { update } = parent.dataset;
                if (update) {
                  const inputs = parent.querySelectorAll(
                    `input[name=mobCntyCd]`
                  );
                  Array.from(inputs).forEach((input: any) => {
                    input.setAttribute("data-type", "U");
                  });
                }
              }}
            >
              <span>{cnty[lng as keyof lngProps]}</span>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
